import { createClient } from '@supabase/supabase-js'
import { decodeJwt } from 'jose'
import { v5 as uuidV5, NIL } from 'uuid'

import { SUPABASE_URL, SUPABASE_ANON_KEY } from '@/constants/configs'

const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {})

export default supabase
export const supabaseAuth = supabase.auth
export const supabaseQuery = supabase
export const supabaseS3 = supabase.storage

export function useAuthGuard(headers: Headers) {
  const bearerToken = headers.get('Authorization')

  if (bearerToken) {
    const accessToken = bearerToken.replace('Bearer', '').trim()
    const payload = decodeJwt(accessToken)

    return {
      uid: payload.sub!,
      email: payload.email as string,
      accessToken
    }
  }

  throw new Response(void 0, { status: 401, statusText: 'Unauthorized' })
}

export async function uploadFile(file: File, bucket: string, pathName: string) {
  const fileName = uuidV5(`${Date.now()}-${file.name}`, NIL) + `.${file.name.split('.').pop()}`
  const { data, error } = await supabaseS3
    .from(bucket)
    .upload(`${pathName}/${fileName}`, file, { contentType: file.type })

  if (error) throw error

  if (data) {
    const result = supabaseS3.from(bucket).getPublicUrl(data.path)
    return result.data.publicUrl
  }

  return '/static/images/404.jpg'
}

export async function deleteFile(bucket: string, publicUrl: string[]) {
  const paths = publicUrl.map((url) => url.split(`/${bucket}/`)[1])
  return await supabaseS3.from(bucket).remove(paths)
}
